import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import "../styles/refundDashboardStyles.scss";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import FontIcon from "react-md/lib/FontIcons";
import goIcon from "../../../../../assets/icons/right_arrow_go_btn.svg";
import EventService from "../../../../../service/event/EventService";
import moment from "moment";
import Button from "react-md/lib/Buttons/Button";
import GlobalSkeletonLoader from "../../../../../components/common/GlobalSkeletonLoader";
import RefundDashboardUtils from "../services/RefundDashboardUtils";
import Helper from "util/Helper";
import RefreshButton from "../../navigo-module/helper/RefreshButton";
import { DialogContainer } from "react-md";
import { formatCurrency } from "../../navigo-module/helper/formatCurrency";
import InfoButton from "../../account-module/helper/InfoButton";

function RefundDashboard(props) {
  const [appointmentsList, setAppointmentsList] = useState([]);
  const [componentMounted, setComponentMounted] = useState(false);
  const refundDashboardUtils = new RefundDashboardUtils();
  const helper = new Helper();
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [filterObj, setFilterObj] = useState({
    pageNum: 1,
    pageSize: 30,
  });
  const [onlyPageChange, setOnlyPageChange] = useState(false);
  const [noAppointments, setNoAppointments] = useState(true);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [numFrom, setNumFrom] = useState(0);
  const [numTo, setNumTo] = useState(0);
  const [refundDateFrom, setRefundDateFrom] = useState(null);
  const [refundDateTo, setRefundDateTo] = useState(null);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openFilter, setOpenFilter] = useState(0);
  const [maxDate, setMaxDate] = useState("");
  const skip = useRef(30);
  const [createdByFilterValue, setCreatedByFilterValue] = useState([]);
  const [statusFilterValue, setStatusFilterValue] = useState([]);
  const [removeFilters, setRemoveFilters] = useState(false);
  const [refundIdFilterText, setRefundIdFilterText] = useState("");
  const [orderIdFilterText, setOrderIdFilterText] = useState("");
  const [patientIdFilterText, setPatientIdFilterText] = useState("");
  const [aptIdFilterText, setAptIdFilterText] = useState("");
  const [razorPayDetails, setRazorPayDetails] = useState(null);
  const [refundFailedDetails, setRefundFailedDetails] = useState(null);
  const [refundReasonDetails, setRefundReasonDetails] = useState(null);

  const allStatusList = [
    {
      value: 0,
      name: "Initiated",
      colorLight: "#FFF9E3",
      colorDark: "#FFBC2E",
    },
    {
      value: 1,
      name: "In progress",
      colorLight: "#FFF9E3",
      colorDark: "#FFBC2E",
    },
    {
      value: 2,
      name: "Successful",
      colorLight: "#CBECDE",
      colorDark: "#0A5033",
    },
    { value: 3, name: "Failed", colorLight: "#FBDFD9", colorDark: "#E54336" },
  ];

  const allCreatedByList = [
    { value: 1, name: "Patient" },
    { value: 2, name: "Employee" },
    { value: 3, name: "System generated" },
    { value: 4, name: "Expert" },
    { value: 5, name: "Service provider" },
  ];

  const getButtonStyle = (color) => {
    const base = {
      cursor: "pointer",
      marginLeft: "10px",
      minWidth: "125px",
      textTransform: "none",
      fontSize: "medium",
      borderRadius: "5px",
      color: "#FFFFFF",
    };

    switch (color) {
      case "zyOrange":
        return { ...base, backgroundColor: "#F77F11" };
      case "zyGreen":
        return { ...base, backgroundColor: "#04C9D3" };
      case "zyDisabled":
        return { ...base, backgroundColor: "#C2C2C2" };
      default:
        return { ...base, backgroundColor: "#EBEBEB", color: "#333333" };
    }
  };

  useEffect(() => {
    handleGetAllAppointments();
    setComponentMounted(true);
  }, []);

  useEffect(() => {
    if (componentMounted && onlyPageChange == true) {
      setFilterObj({ ...filterObj, pageNum: pageNum });
    }
  }, [onlyPageChange]);
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setMaxDate(today);
  }, []);

  useEffect(() => {
    if (componentMounted) {
      skip.current = 30;
      handleGetAllAppointments();
    }
  }, [filterObj]);

  const handleGetAllAppointments = (type = 1, btnType = 0) => {
    setLoading(true);

    refundDashboardUtils.fetchRefundsByFilter(
      filterObj,
      (res) => {
        setOnlyPageChange(false);
        if (res && res.refunds && res.refunds.length > 0) {
          let allList = [];

          allList = res.refunds.map((service) => {
            return { ...service };
          });
          let localNumFrom, localNumTo;
          if (type === 1) {
            localNumFrom = 1;
            localNumTo = Math.min(30, res.resultCount);
          } else if (type === 2) {
            if (btnType === 0) {
              localNumTo = numFrom - 1;
              localNumFrom = Math.max(numFrom - 30, 1);
            } else {
              localNumFrom = numTo + 1;
              localNumTo = Math.min(numTo + 30, res.resultCount);
            }
          } else if (type === 3) {
            localNumFrom = numFrom;
            localNumTo = numTo;
          }
          setAppointmentsList([...allList]);
          setNoAppointments(false);
          setNumFrom(localNumFrom);
          setNumTo(localNumTo);
          setTotalCount(res.totalCount);
          setLoading(false);
        } else {
          setAppointmentsList([]);
          setNoAppointments(true);
          setLoading(false);
        }
        setRemoveFilters(false);
      },
      (err) => {
        setLoading(false);
        setAppointmentsList([]);
        setNoAppointments(true);
        setRemoveFilters(false);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  const handlePrevNextAppoint = (arg) => {
    setOnlyPageChange(true);
    if (arg) {
      setPageNum((prevPage) => prevPage + 1);
    } else {
      if (pageNum > 1) {
        setPageNum((prevPage) => (prevPage > 1 ? prevPage - 1 : 1));
      }
    }
  };

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        createdBy: createdByFilterValue.map((e) => e.value),
      });
      setPageNum(1);
    }
  }, [createdByFilterValue]);

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        status: statusFilterValue.map((e) => e.value),
      });
      setPageNum(1);
    }
  }, [statusFilterValue]);

  const onRefresh = () => {
    handleGetAllAppointments();
  };

  const areFiltersApplied = () => {
    if (
      filterObj?.refundDate?.from != null ||
      filterObj?.refundDate?.to != null ||
      filterObj?.refundId?.length > 0 ||
      filterObj?.orderId?.length > 0 ||
      filterObj?.patientId > 0 ||
      filterObj?.appointmentId > 0 ||
      filterObj?.createdBy?.length > 0 ||
      filterObj?.status?.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };
  const resetFilters = () => {
    let resetFilterObj = filterObj;
    delete resetFilterObj.refundId;
    delete resetFilterObj.orderId;
    delete resetFilterObj.patientId;
    delete resetFilterObj.appointmentId;
    delete resetFilterObj.refundDate;
    delete resetFilterObj.status;
    delete resetFilterObj.createdBy;

    setFilterObj({
      ...resetFilterObj,
      pageNum: 1,
    });
    setPageNum(1);
    setOpenFilter(0);
    setOpenBackdrop(false);
  };
  useEffect(() => {
    if (removeFilters === true) {
      setCreatedByFilterValue([]);
      setStatusFilterValue([]);
      setRefundIdFilterText("");
      setOrderIdFilterText("");
      setPatientIdFilterText("");
      setAptIdFilterText("");

      resetFilters();
    }
  }, [removeFilters]);
  useEffect(() => {
    if (componentMounted) {
      onRefresh();
    }
  }, [props.dashboardKeyReload]);

  const TableRow = ({ label, value }) => (
    <tr
      style={{
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      <td
        style={{
          padding: "10px 12px",
          fontWeight: 600,
          width: "180px",
          background: "#fafafa",
        }}
      >
        {label}:
      </td>

      <td
        style={{
          padding: "10px 12px",
        }}
      >
        {value || "-"}
      </td>
    </tr>
  );

  const capitalizeFirst = (str) =>
    typeof str === "string" && str.length > 0
      ? str.charAt(0).toUpperCase() + str.slice(1)
      : str;

  return (
    <div className="refund-module-dashboard-table-container">
      <div className="navigo-appoint-container">
        <div className="navigo-appoint-section-8">
          <div
            className="navigo-appoint-section-1"
            onClick={() => {
              helper.navigateTo(props, "/");
            }}
          >
            <FontIcon style={{ fontSize: "36px" }}>arrow_back</FontIcon>
          </div>
          <h1 className="navigo-appoint-section-2">Refund dashboard</h1>
          <RefreshButton onRefresh={onRefresh} loading={loading} />
          <div className="navigo-appoint-section-4-bottom-button-container"></div>
        </div>
        {/* ________________ */}

        <div className="navigo-appoint-section-5">
          <div className="navigo-appoint-section-5-grid-container">
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Refund <br /> ID
              </p>
              <img
                src={
                  filterObj?.refundId?.length > 0 ? filterApplied : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(1);
                }}
              />
              {openFilter === 1 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-search-text-left">
                  <TextField
                    id="appointment-dialog-client-code-filter-refund-id"
                    className="appointment-dialog-client-code-filter-class"
                    placeholder="Refund ID"
                    value={refundIdFilterText}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(
                        /[^a-zA-Z0-9-_]/g,
                        "",
                      );
                      if (inputValue.length > 30) {
                        inputValue = inputValue.slice(0, 30);
                      }
                      setRefundIdFilterText(inputValue);
                    }}
                    inputProps={{
                      maxLength: 30,
                    }}
                    InputProps={{
                      endAdornment: refundIdFilterText && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setRefundIdFilterText("");
                              let removedFilterObj = { ...filterObj };
                              delete removedFilterObj.refundId;
                              setFilterObj({
                                ...removedFilterObj,
                                pageNum: 1,
                              });
                              setPageNum(1);
                            }}
                            edge="end"
                            size="small"
                          >
                            <FontIcon>close</FontIcon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div
                    style={{ display: "flex", cursor: "pointer" }}
                    onClick={() => {
                      if (refundIdFilterText.trim()) {
                        const refundId = refundIdFilterText.trim();

                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          refundId,
                        });
                        setPageNum(1);
                      }
                    }}
                  >
                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "28px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Order ID
                <br />
              </p>
              <img
                src={
                  filterObj?.orderId?.length > 0 ? filterApplied : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(2);
                }}
              />
              {openFilter === 2 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-search-text-center">
                  <TextField
                    id="appointment-dialog-client-code-filter-order-id"
                    className="appointment-dialog-client-code-filter-class"
                    placeholder="Order ID"
                    value={orderIdFilterText}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(
                        /[^a-zA-Z0-9-_]/g,
                        "",
                      );
                      if (inputValue.length > 30) {
                        inputValue = inputValue.slice(0, 30);
                      }
                      setOrderIdFilterText(inputValue);
                    }}
                    inputProps={{
                      maxLength: 30,
                    }}
                    InputProps={{
                      endAdornment: orderIdFilterText && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setOrderIdFilterText("");
                              let removedFilterObj = { ...filterObj };
                              delete removedFilterObj.orderId;
                              setFilterObj({
                                ...removedFilterObj,
                                pageNum: 1,
                              });
                              setPageNum(1);
                            }}
                            edge="end"
                            size="small"
                          >
                            <FontIcon>close</FontIcon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div
                    style={{ display: "flex", cursor: "pointer" }}
                    onClick={() => {
                      if (orderIdFilterText.trim()) {
                        const orderId = orderIdFilterText.trim();

                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          orderId,
                        });
                        setPageNum(1);
                      }
                    }}
                  >
                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "28px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Appointment <br /> ID
              </p>
              <img
                src={filterObj?.appointmentId > 0 ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(3);
                }}
              />
              {openFilter === 3 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-search-text-center">
                  <TextField
                    id="appointment-dialog-client-code-filter-appointment-id"
                    className="appointment-dialog-client-code-filter-class"
                    placeholder="Appointment ID"
                    value={aptIdFilterText}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(/[^0-9]/g, "");

                      if (inputValue.length > 30) {
                        inputValue = inputValue.slice(0, 30);
                      }
                      setAptIdFilterText(inputValue);
                    }}
                    inputProps={{
                      maxLength: 30,
                    }}
                    InputProps={{
                      endAdornment: aptIdFilterText && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setAptIdFilterText("");
                              let removedFilterObj = { ...filterObj };
                              delete removedFilterObj.appointmentId;
                              setFilterObj({
                                ...removedFilterObj,
                                pageNum: 1,
                              });
                              setPageNum(1);
                            }}
                            edge="end"
                            size="small"
                          >
                            <FontIcon>close</FontIcon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div
                    style={{ display: "flex", cursor: "pointer" }}
                    onClick={() => {
                      if (aptIdFilterText.trim()) {
                        const appointmentIdNum = parseInt(
                          aptIdFilterText.trim(),
                          10,
                        );

                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          appointmentId: appointmentIdNum,
                        });
                        setPageNum(1);
                      }
                    }}
                  >
                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "28px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Patient <br /> ID
              </p>
              <img
                src={filterObj?.patientId > 0 ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(5);
                }}
              />
              {openFilter === 5 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-search-text-center">
                  <TextField
                    id="appointment-dialog-client-code-filter-patient-id"
                    className="appointment-dialog-client-code-filter-class"
                    placeholder="Patient ID"
                    value={patientIdFilterText}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(
                        /[^a-zA-Z0-9-_]/g,
                        "",
                      );
                      if (inputValue.length > 30) {
                        inputValue = inputValue.slice(0, 30);
                      }
                      setPatientIdFilterText(inputValue);
                    }}
                    inputProps={{
                      maxLength: 30,
                    }}
                    InputProps={{
                      endAdornment: patientIdFilterText && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setPatientIdFilterText("");
                              let removedFilterObj = { ...filterObj };
                              delete removedFilterObj.patientId;
                              setFilterObj({
                                ...removedFilterObj,
                                pageNum: 1,
                              });
                              setPageNum(1);
                            }}
                            edge="end"
                            size="small"
                          >
                            <FontIcon>close</FontIcon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div
                    style={{ display: "flex", cursor: "pointer" }}
                    onClick={() => {
                      if (patientIdFilterText.trim()) {
                        const patientIdNum = parseInt(
                          patientIdFilterText.trim(),
                          10,
                        );

                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          patientId: patientIdNum,
                        });
                        setPageNum(1);
                      }
                    }}
                  >
                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "28px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Refund <br /> date
              </p>
              <img
                src={
                  filterObj?.refundDate?.from || filterObj?.refundDate?.to
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(4);
                }}
              />
              {openFilter === 4 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                  <div className="navigo-appointment-date-range-filter ">
                    <p>From</p>
                    <TextField
                      type="date"
                      style={{ width: "90%" }}
                      className="dob"
                      id="dob"
                      onChange={(v) => {
                        if (v.target.value) {
                          setRefundDateFrom(v.target.value);
                        }
                      }}
                      // inputProps={{ max: maxDate }}
                      value={refundDateFrom}
                    ></TextField>
                  </div>
                  <div className="navigo-appointment-date-range-filter ">
                    <p>To</p>
                    <TextField
                      type="date"
                      defaultValue={""}
                      style={{ width: "90%" }}
                      className="dob"
                      id="dob"
                      onChange={(v) => {
                        if (v.target.value) {
                          setRefundDateTo(v.target.value);
                        }
                      }}
                      // inputProps={{ max: maxDate }}
                      value={refundDateTo}
                    ></TextField>
                  </div>
                  <Button
                    className=""
                    style={{
                      padding: "3px",
                      margin: "0px 5px",
                      backgroundColor: "#c3c3c3",
                    }}
                    onClick={() => {
                      setFilterObj({
                        ...filterObj,
                        pageNum: 1,
                        refundDate: {
                          from: moment(refundDateFrom)
                            .utc()
                            .startOf("day")
                            .add(1, "day")
                            .toISOString(),

                          to: moment(refundDateTo)
                            .utc()
                            .endOf("day")
                            .add(1, "day")
                            .toISOString(),
                        },
                      });
                      setPageNum(1);
                      setOpenFilter(0);
                      setOpenBackdrop(false);
                    }}
                  >
                    Go
                  </Button>
                  <Button
                    className=""
                    onClick={() => {
                      let removedFilterObj = filterObj;
                      delete removedFilterObj.refundDate;
                      setFilterObj({
                        ...removedFilterObj,
                        pageNum: 1,
                      });
                      setRefundDateFrom(null);
                      setRefundDateTo(null);
                      setPageNum(1);
                      setOpenFilter(0);
                      setOpenBackdrop(false);
                    }}
                  >
                    <FontIcon className="">close</FontIcon>
                  </Button>
                </div>
              )}
            </div>
            {/* <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p></p>
            </div> */}

            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Initiated <br /> by
              </p>
              <img
                src={
                  createdByFilterValue.length > 0 ? filterApplied : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(7);
                }}
              />
              {openFilter === 7 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-search-text-center">
                  <Autocomplete
                    multiple
                    id="navigo-appointment-dialog-client-code-filter"
                    className="appointment-dialog-client-code-filter-class"
                    options={allCreatedByList}
                    value={createdByFilterValue} //createdByFilterValue
                    onChange={(e, v) => {
                      if (v.length > 0) {
                        setCreatedByFilterValue(v);
                      } else {
                        setCreatedByFilterValue([]);
                      }
                    }}
                    getOptionLabel={(option) => {
                      return option.name;
                    }}
                    // filterOptions={(x) => x}
                    getOptionDisabled={(option) =>
                      Array.isArray(filterObj?.createdBy) &&
                      filterObj?.createdBy.includes(option.value)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={"Type initiated by name"}
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Refund <br /> amount
              </p>
            </div>
            <div className="navigo-appoint-section-5-grid-container-common-section ">
              <p>
                Status <br /> &nbsp;
              </p>
              <img
                src={statusFilterValue.length > 0 ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(10);
                }}
              />
              {openFilter === 10 && (
                <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-right">
                  <Autocomplete
                    multiple
                    id="navigo-appointment-dialog-client-code-filter"
                    className="appointment-dialog-client-code-filter-class"
                    options={allStatusList}
                    value={statusFilterValue} //statusFilterValue
                    onChange={(e, v) => {
                      if (v.length > 0) {
                        setStatusFilterValue(v);
                      } else {
                        setStatusFilterValue([]);
                      }
                    }}
                    getOptionLabel={(option) => {
                      return option.name;
                    }}
                    // filterOptions={(x) => x}
                    getOptionDisabled={(option) =>
                      Array.isArray(filterObj?.status) &&
                      filterObj?.status.includes(option.value)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={"Type status name"}
                        className="autocomplete-text-field-class"
                      />
                    )}
                  />
                </div>
              )}
            </div>
            {areFiltersApplied() && (
              <div
                onClick={() => {
                  setRemoveFilters(true);
                }}
                style={{
                  display: "inline-block",
                  cursor: "pointer",
                }}
              >
                <FontIcon style={{ fontSize: "22px" }}>
                  highlight_remove
                </FontIcon>
              </div>
            )}
          </div>
        </div>
        <div className="navigo-appoint-section-6">
          {appointmentsList && appointmentsList.length > 0 && (
            <div className="navigo-appoint-bottom-bar">
              <Button
                className="navigo-appoint-bottom-bar-button"
                onClick={() => {
                  handlePrevNextAppoint(0);
                }}
                disabled={pageNum == 1 || loading}
              >
                <FontIcon className="navigo-count-icon">arrow_drop_up</FontIcon>
              </Button>
              <div className="navigo-appoint-bottom-bar-text">
                Showing&nbsp;
                <span
                  style={{
                    color: "#ef7c01",
                  }}
                >
                  {(pageNum - 1) * pageSize + 1}&nbsp;- &nbsp;
                  {totalCount > pageNum * pageSize
                    ? pageNum * pageSize
                    : totalCount}
                </span>
                <span>&nbsp;of&nbsp;</span>
                <span>{` ${totalCount}`}</span>
              </div>
              <Button
                className="navigo-appoint-bottom-bar-button"
                onClick={() => {
                  handlePrevNextAppoint(1);
                }}
                disabled={
                  loading ||
                  pageNum * pageSize > totalCount ||
                  (totalCount > pageNum * pageSize
                    ? pageNum * pageSize
                    : totalCount) == totalCount
                }
              >
                <FontIcon className="navigo-count-icon">
                  arrow_drop_down
                </FontIcon>
              </Button>
            </div>
          )}
          {loading == false && (
            <div className="navigo-appoint-section-6-list">
              {appointmentsList &&
                appointmentsList.map((ele) => {
                  const bothRefundApplicable =
                    ele?.walletRefund?.isApplicable &&
                    ele?.externalRefund?.isApplicable;

                  return (
                    <div
                      className="navigo-appoint-section-6-grid-container"
                      key={ele.id}
                    >
                      <div
                        className={`general-font-class ${
                          bothRefundApplicable ? "no-ellipsis" : ""
                        }`}
                      >
                        {ele?.id ?? "—"}
                      </div>

                      <div
                        className={`general-font-class ${
                          bothRefundApplicable ? "no-ellipsis" : ""
                        }`}
                      >
                        {ele?.orderId ?? "—"}
                      </div>

                      <div
                        className={`general-font-class ${
                          bothRefundApplicable ? "no-ellipsis" : ""
                        }`}
                      >
                        {ele?.appointmentId === 0 ||
                        ele?.appointmentId == null ? (
                          "—"
                        ) : (
                          <a
                            className="general-font-class general-cursor-pointer navigo-appointment-break-word-class"
                            href={`/navigo-module?view=2&appId=${ele.appointmentId}`}
                            target="_blank"
                          >
                            {ele.appointmentId}
                          </a>
                        )}
                      </div>

                      <div
                        className={`general-font-class ${
                          bothRefundApplicable ? "no-ellipsis" : ""
                        }`}
                      >
                        {!ele?.patientId ? (
                          "—"
                        ) : (
                          /* The patient's HEALTH RECORD — bridge's phr record,
                              /patient-record/:patientId (App.js) — in the SAME
                              tab, as a router Link (Nittin, 2026-09-25). It
                              opened the legacy /patients/{id}/new-bridge screen
                              in a new one; the appointment-details screen, the
                              appointments-v2 board and the claims dashboard all
                              made this same swap. Still an <a> underneath, so it
                              can be middle-clicked or copied. */
                          <Link
                            className="general-font-class general-cursor-pointer navigo-appointment-break-word-class"
                            to={`/patient-record/${ele.patientId}`}
                          >
                            {ele.patientId}
                          </Link>
                        )}
                      </div>

                      <div
                        className={`general-font-class ${
                          bothRefundApplicable ? "no-ellipsis" : ""
                        }`}
                      >
                        {ele?.createdAt
                          ? moment(ele.createdAt).format("DD MMM YYYY hh:mm A")
                          : "—"}
                      </div>

                      {/* <div
                        className={`general-font-class ${
                          bothRefundApplicable ? "no-ellipsis" : ""
                        }`}
                      >
                        {""}
                      </div> */}
                      <div
                        className={`general-font-class ${
                          bothRefundApplicable ? "no-ellipsis" : ""
                        }`}
                      >
                        {ele?.createdBy === 1
                          ? "Patient"
                          : ele?.createdBy === 2
                            ? `Emp (${ele?.createdById}) ${ele?.createdByName}`
                            : ele?.createdBy === 3
                              ? "System generated"
                              : ele?.createdBy === 4
                                ? `Exp (${ele?.createdById}) ${ele?.createdByName}`
                                : ele?.createdBy === 5
                                  ? "Service provider"
                                  : "—"}
                      </div>

                      <div
                        className={`general-font-class ${
                          bothRefundApplicable ? "no-ellipsis" : ""
                        }`}
                      >
                        {(() => {
                          const hasWallet =
                            ele?.walletRefund?.isApplicable === true;
                          const hasExternal =
                            ele?.externalRefund?.isApplicable === true;

                          if (!hasWallet && !hasExternal) {
                            return "—";
                          }

                          return (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {hasWallet && (
                                <span>
                                  {`Wallet: ${formatCurrency(
                                    ele?.walletRefund?.amount,
                                  )}`}
                                </span>
                              )}
                              {bothRefundApplicable && (
                                <span style={{ height: "6px" }}>{""}</span>
                              )}
                              {hasExternal && (
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setRazorPayDetails(ele?.externalRefund);
                                  }}
                                >
                                  {`Razorpay: ${formatCurrency(
                                    ele?.externalRefund?.amount,
                                  )}`}
                                </span>
                              )}
                            </div>
                          );
                        })()}
                      </div>

                      <div className="navigo-appoint-section-6-grid-status">
                        {(() => {
                          const statusDiv = (status, type) => {
                            const statusObj = allStatusList.find(
                              (s) => s.value === status,
                            );
                            if (!statusObj) return null;

                            const isFailed = status === 3;

                            return (
                              <div
                                style={{
                                  backgroundColor: statusObj.colorLight,
                                  color: statusObj.colorDark,
                                  padding: "1px 10px",
                                  borderRadius: "20px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  fontWeight: 900,
                                  fontSize: "13px",
                                  width: "124px",
                                  marginBottom:
                                    bothRefundApplicable && type === 1
                                      ? "11px"
                                      : "2px",
                                  cursor: isFailed ? "pointer" : "default",

                                  justifyContent: "center",
                                }}
                                onClick={() => {
                                  if (isFailed) {
                                    setRefundFailedDetails({
                                      data: ele,
                                      type: type,
                                    });
                                  }
                                }}
                              >
                                {statusObj.name}

                                {isFailed && (
                                  <div style={{ marginLeft: "10px" }}>
                                    <FontIcon style={{ color: "#E54336" }}>
                                      info_outline
                                    </FontIcon>
                                  </div>
                                )}
                              </div>
                            );
                          };

                          const hasWallet =
                            ele?.walletRefund?.isApplicable === true;
                          const hasExternal =
                            ele?.externalRefund?.isApplicable === true;

                          if (!hasWallet && !hasExternal)
                            return <span style={{ color: "#777" }}>—</span>;

                          return (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {hasWallet &&
                                statusDiv(ele?.walletRefund?.status, 1)}
                              {hasExternal &&
                                statusDiv(ele?.externalRefund?.status, 2)}
                            </div>
                          );
                        })()}
                      </div>
                      <div
                        className={`general-font-class ${
                          bothRefundApplicable ? "max-2-lines" : ""
                        }`}
                      >
                        {ele?.reason ? (
                          <InfoButton
                            onClick={() => setRefundReasonDetails(ele.reason)}
                          />
                        ) : (
                          ""
                        )}
                      </div>

                      {/* <IconButton
                        onClick={() => {}}
                        className="navigo-appoint-section-6-grid-edit-call"
                      >
                        <OptionsIcon />
                      </IconButton> */}
                    </div>
                  );
                })}
            </div>
          )}

          {loading && <GlobalSkeletonLoader />}
          {loading === false && noAppointments && (
            <div className="no-appointments-container">
              <p>No refunds found!</p>
            </div>
          )}
        </div>

        {openBackdrop && (
          <div
            className="navigo-appointment-backdrop-class"
            onClick={() => {
              setOpenFilter(0);
              setOpenBackdrop(false);
            }}
          ></div>
        )}

        {razorPayDetails && (
          <div className="custom-dialog-overlay-razor">
            <DialogContainer
              id="razor-details-dialog"
              visible={razorPayDetails != null}
              onHide={() => {
                setRazorPayDetails(null);
              }}
              focusOnMount={false}
              autosizeContent
              width={"800px"}
              dialogStyle={{
                borderRadius: "10px",
                padding: "15px",
              }}
            >
              <div style={{ fontFamily: "Montserrat", color: "#000" }}>
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    style={{
                      margin: 0,
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "600",
                    }}
                  >
                    Razor pay refund details
                  </div>
                  <FontIcon
                    style={{
                      cursor: "pointer",
                      fontSize: "22px",
                      color: "#777",
                    }}
                    onClick={() => {
                      setRazorPayDetails(null);
                    }}
                  >
                    close
                  </FontIcon>
                </div>

                <div
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "12px",
                    padding: "0",
                    overflow: "hidden",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "14px",
                    }}
                  >
                    <tbody>
                      {(() => {
                        const refundFields = [
                          {
                            label: "Refund ID",
                            value: razorPayDetails?.refundId,
                          },
                          {
                            label: "Payment ID",
                            value: razorPayDetails?.paymentId,
                          },
                          {
                            label: "Order ID",
                            value: razorPayDetails?.orderId,
                          },
                          {
                            label: "Speed requested",
                            value: capitalizeFirst(
                              razorPayDetails?.speedRequested,
                            ),
                          },
                          {
                            label: "Speed processed",
                            value: capitalizeFirst(
                              razorPayDetails?.speedProcessed,
                            ),
                          },
                          {
                            label: "Amount",
                            value: razorPayDetails?.amount
                              ? formatCurrency(razorPayDetails?.amount)
                              : null,
                          },
                          {
                            label: "Failed reason",
                            value: razorPayDetails?.failedReason,
                          },
                          {
                            label: "ARN Reference number",
                            value: razorPayDetails?.acquirerData?.arn,
                          },
                          {
                            label: "RRN Reference number",
                            value: razorPayDetails?.acquirerData?.rrn,
                          },
                          {
                            label: "UTR Reference number",
                            value: razorPayDetails?.acquirerData?.utr,
                          },
                        ];

                        return refundFields
                          .filter(
                            (f) =>
                              f.value !== null &&
                              f.value !== undefined &&
                              f.value !== "",
                          )
                          .map((f) => (
                            <TableRow
                              key={f.label}
                              label={f.label}
                              value={f.value}
                            />
                          ));
                      })()}
                    </tbody>
                  </table>
                </div>
              </div>
            </DialogContainer>
          </div>
        )}
        {refundFailedDetails && (
          <div className="custom-dialog-overlay-razor">
            <DialogContainer
              id="razor-details-dialog"
              visible={refundFailedDetails != null}
              onHide={() => {
                setRefundFailedDetails(null);
              }}
              focusOnMount={false}
              autosizeContent
              width={"800px"}
              dialogStyle={{
                borderRadius: "10px",
                padding: "15px",
              }}
            >
              <div style={{ fontFamily: "Montserrat", color: "#000" }}>
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    style={{
                      margin: 0,
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "600",
                    }}
                  >
                    Refund failed
                  </div>
                  <FontIcon
                    style={{
                      cursor: "pointer",
                      fontSize: "22px",
                      color: "#777",
                    }}
                    onClick={() => {
                      setRefundFailedDetails(null);
                    }}
                  >
                    close
                  </FontIcon>
                </div>
                {/* Refund details */}
                <br />
                <div style={{ textAlign: "center" }}>
                  Reason:{" "}
                  {refundFailedDetails.type === 1
                    ? refundFailedDetails.data?.walletRefund?.failedReason
                    : refundFailedDetails.type === 2
                      ? refundFailedDetails.data?.externalRefund?.failedReason
                      : ""}
                </div>
                {/* <div style={{ marginTop: "25px", textAlign: "center" }}>
                  <Button
                    raised
                    style={getButtonStyle("zyOrange")}
                    onClick={() => {}}
                  >
                    Retry refund
                  </Button>
                  <Button
                    raised
                    style={getButtonStyle("zyGrey")}
                    onClick={() => {
                      setRefundFailedDetails(null);
                    }}
                  >
                    Go back
                  </Button>
                </div> */}
              </div>
            </DialogContainer>
          </div>
        )}
        {refundReasonDetails && (
          <div className="custom-dialog-overlay-razor">
            <DialogContainer
              id="reason-details-dialog"
              visible={refundReasonDetails != null}
              onHide={() => {
                setRefundReasonDetails(null);
              }}
              focusOnMount={false}
              autosizeContent
              width={"800px"}
              dialogStyle={{
                borderRadius: "10px",
                padding: "15px",
              }}
            >
              <div style={{ fontFamily: "Montserrat", color: "#000" }}>
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    style={{
                      margin: 0,
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "600",
                    }}
                  >
                    Refund reason
                  </div>
                  <FontIcon
                    style={{
                      cursor: "pointer",
                      fontSize: "22px",
                      color: "#777",
                    }}
                    onClick={() => {
                      setRefundReasonDetails(null);
                    }}
                  >
                    close
                  </FontIcon>
                </div>
                <br />
                <div style={{ textAlign: "center" }}>
                  Reason: {refundReasonDetails}
                </div>
              </div>
            </DialogContainer>
          </div>
        )}
      </div>
    </div>
  );
}

export default RefundDashboard;
